import * as React from "react";
const SvgContacts = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#969696", d: "M4 17.5a6 6 0 1 1 12 0zm6-6.75a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9" }));
export default SvgContacts;
